import calendarService from '@/api/calendar'
import { CALENDAR_SET } from '../types'

export default {
  namespaced: true,
  state: {
    calendar: {
      botAccountEmail: '',
      certificate: '',
      calendarType: null,
      occurrencesLimit: 0,
      multipleRooms: ''
    }
  },
  getters: {
  },
  mutations: {
    [CALENDAR_SET] (state, calendar) {
      state.calendar = calendar
    }
  },
  actions: {
    getCalendarConfiguration: function ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        dispatch('Global/showLoading', null, {root: true})
        calendarService.getCalendarConfiguration().then((response) => {
          if (response.data) {
            commit(CALENDAR_SET, response.data)
          }
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(()=>{
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    saveCalendarConfiguration: function ({commit}, calendar) {
      return new Promise((resolve, reject) => {
        calendarService.saveCalendarConfiguration(calendar).then(() => {
          commit(CALENDAR_SET, calendar)
          if (calendar.calendarType === 'microsoftCalendar') {
            // obter url para autorização
            calendarService.getAuthorizationUrl().then(response => {
              resolve(response.data)
            }).catch((error) => {
              reject(error)
            })
          } else {
            resolve()
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    saveCertificate: async function ({}, certificate) {
      await calendarService.saveCertificate(certificate)
    },
    getAuthorizationUrl () {
      return calendarService.getAuthorizationUrl()
    }
  }
}
